import React, {
  useReducer,
  createContext,
  useContext,
  useEffect,
  Fragment,
} from 'react';
import { useParams } from 'react-router-dom';
import TwoCards from '../../../../../../components/Card/TwoCards';
import FreightMainCard from './FreightMainCard';
import FreightFormCard from './FreightFormCard';
import { reducer, initialState } from './reducer';
import Chip from '@material-ui/core/Chip';
import green from '@material-ui/core/colors/green';
import blueGray from '@material-ui/core/colors/blueGrey';
import { store as mainStore } from '../../../../../../store';
import useTitle from 'hooks/useTitle';
import FullCard from 'components/Card/FullCard';

export const store = createContext(null);
const { Provider } = store;

const Freight = () => {
  var { id } = useParams();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { state: mainState, showMessage, showError } = useContext(mainStore);
  const { itemsCountPerPage } = mainState.Props;
  const { freight } = state;

  const {
    fetchingUserData,
    fetchingOrders,
    fetchingNotes,
    fetchingPhones,
  } = state;

  const fetchingFreightData = async () => {
    const userData = await fetchingUserData(id);
    dispatch({
      type: 'LOAD',
      payload: { name: 'freight', value: userData },
    });
  };

  const fetchingFreightPhones = async () => {
    const phones = await fetchingPhones(id);
    dispatch({
      type: 'LOAD',
      payload: { name: 'phones', value: phones },
    });
  };
  const fetchingFreightNotes = async () => {
    const notes = await fetchingNotes(id);
    dispatch({ type: 'LOAD', payload: { name: 'notes', value: notes } });
  };
  const fetchingFreightOrders = async () => {
    const orders = await fetchingOrders(id, 1, itemsCountPerPage);
    dispatch({ type: 'LOAD', payload: { name: 'orders', value: orders } });
  };

  const fetchingAllDatas = (whatToRefresh) => {
    if (whatToRefresh) {
      if (whatToRefresh === 'fetchingFreightPhones') fetchingFreightPhones();
    }
    fetchingFreightData();
    fetchingFreightPhones();
    fetchingFreightNotes();
    fetchingFreightOrders();
  };

  useEffect(() => {
    fetchingAllDatas();
  }, []);
  useTitle(`${freight?.company}`);

  return (
    <Provider
      value={{
        state,
        dispatch,
        refresh: fetchingAllDatas,
        showMessage,
        showError,
      }}
    >
      <TwoCards
        title={
          <Fragment>
            {freight
              ? freight.legal
                ? `${
                    freight.company
                      ? freight.company
                      : 'نام شرکت هنوز وارد نشده است'
                  }`
                : `${freight.firstName} ${freight.lastName}`
              : null}
            <Chip
              variant="outlined"
              color="secondary"
              size="small"
              label={freight && freight.online ? `آنلاین` : `آفلاین`}
              style={{
                marginRight: 5,
                color: freight && freight.online ? green[500] : blueGray[500],
                borderColor:
                  freight && freight.online ? green[500] : blueGray[500],
              }}
            />
          </Fragment>
        }
        secondaryContent={<FreightFormCard />}
      >
        <FreightMainCard />
      </TwoCards>
    </Provider>
  );
};

export default React.memo(Freight);
